import { useEffect, useState } from 'react';
import { CardFlows } from '@shared/api/rest/users';

export const useCardFlow = (value?: CardFlows[], id?: number) => {
  const [cardFlow, setCardFlow] = useState<CardFlows>();

  useEffect(() => {
    if (value && value?.length > 0 && id) {
      const card = value.filter((x) => x.cardId === id);
      if (card.length > 0) {
        setCardFlow(card[0]);
      }
    }
  }, [value]);

  return cardFlow;
};
